import React,{ useEffect, useState, useRef  } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { formatNumber, CTicksToDateStringRemainTime, formatTotalTime } from '../Utility.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';

function Title(props)
{
    const state=useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const audioRef = useRef(null);

        // 5분마다 카운트 가져오기
        useEffect(() => {
            const waitCount = async () => {
                try
                {
                    //if(state.Request === 1)
                    //{
                    //    return;
                    //}

                    var secretkey = sessionStorage.getItem("secret_key");
                    if(secretkey === null)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                        return;    
                    }
                    
                    //dispatch({type:'Request'});
                    const response = await fetch(GetUrl() + 'Admin/AdminRechargePointWaitCount', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ secret_key : secretkey}),
                    });

                    if (response.ok) {
                        const data = await response.json();
                        if(data.result === 0)
                        {
                            dispatch({type:'UpdateRechargeWaitCount', count:data.total_count});  

                            if (audioRef.current && data.total_count > 0) {
                                audioRef.current.play().catch(e => {
                                    console.error('사운드 재생 실패:', e);
                                });
                            }
                        }
                        else if(data.result === 3 ||
                                data.result === 1)
                        {
                            alert('유저 정보 만료(다시 로그인 해주세요)');  
                            navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                        }
                    } 
                    else
                    {
                        alert('Network Fail');
                    }

                    const response_qa = await fetch(GetUrl() + 'Admin/AdminQAWaitCount', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ secret_key : secretkey}),
                    });

                    if (response_qa.ok) {
                        const data = await response_qa.json();
                        if(data.result === 0)
                        {
                            dispatch({type:'UpdateQAWaitCount', count:data.total_count});  

                            if (audioRef.current && data.total_count > 0) {
                                audioRef.current.play().catch(e => {
                                    console.error('사운드 재생 실패:', e);
                                });
                            }
                        }
                        else if(data.result === 3 ||
                                data.result === 1)
                        {
                            alert('유저 정보 만료(다시 로그인 해주세요)');  
                            navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                        }
                    } 
                    else
                    {
                        alert('Network Fail');
                    }

                    //dispatch({type:'Response'});
                }
                catch(error)
                {
                    alert('Network Fail');
                    //dispatch({type:'Response'});
                    console.error(error);
                }
            };
    
            waitCount();
            const interval = setInterval(waitCount, 180000); // 3분
            return () => clearInterval(interval);
        }, []);

    function ChangeView(type)
    {
        if(props.DisplayType === type)
        {
            return;
        }

        if(state.Request === 1)
        {
            return;
        }

        if(type === "0")
        {
            dispatch({type:'RefreshMemberFirstRender'});
            navigate('/member'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "1")
        {
            dispatch({type:'RefreshRechargeWaitFirstRender'});
            navigate('/recharge_point_wait'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "2")
        {
            dispatch({type:'RefreshRechargeApplyFirstRender'});
            navigate('/recharge_point_apply'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "3")
        {
            dispatch({type:'RefreshNoticeFirstRender'});
            navigate('/notice'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "4")
        {
            dispatch({type:'RefreshQAWaitFirstRender'});
            navigate('/qa_wait'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "5")
        {
            dispatch({type:'RefreshQAApplyFirstRender'});
            navigate('/qa_apply'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "6")
        {
            dispatch({type:'RefreshFAQFirstRender'});
            navigate('/faq'); // 로그인 성공 시 메인 페이지로 이동
        }
        else if(type === "7")
        {
            dispatch({type:'RefreshGuideFirstRender'});
            navigate('/guide'); // 로그인 성공 시 메인 페이지로 이동
        }                  
        else if(type === "8")
        {
            dispatch({type:'RefreshTermsFirstRender'});
            navigate('/terms'); // 로그인 성공 시 메인 페이지로 이동
        }                              
    }

    function LogOutClick()
    {
        if(window.confirm("로그아웃 하시겠습니까?")) {
            navigate('/login'); // 로그인 성공 시 메인 페이지로 이동            
        }
    }

    return (        
    <div className='title-box'>
         <audio ref={audioRef} src="/sound/stats.mp3" preload="auto" />
        <div className="logo-box">
            <img src="./img/Spoto.png" style={{width:"80px", height:"80px"}}/>
        </div>
        <div className='button-box'>
            <div className="member-text-box" onClick={() => ChangeView("0")}><h2 style={{fontWeight: props.DisplayType === "0" ? "bold" : "normal", borderBottom: props.DisplayType === "0" ? "2px solid" : "0px"}}>맴버</h2></div>
            <div className="point-recharge-wait" onClick={() => ChangeView("1")}><h2 style={{fontWeight: props.DisplayType === "1" ? "bold" : "normal", borderBottom: props.DisplayType === "1" ? "2px solid" : "0px"}}>충전 승인 대기({state.Recharge_Wait_Count})</h2></div>
            <div className="point-recharge-apply" onClick={() => ChangeView("2")}><h2 style={{fontWeight: props.DisplayType === "2" ? "bold" : "normal", borderBottom: props.DisplayType === "2" ? "2px solid" : "0px"}}>충전 승인 완료</h2></div>
            <div className="notice-title" onClick={() => ChangeView("3")}><h2 style={{fontWeight: props.DisplayType === "3" ? "bold" : "normal", borderBottom: props.DisplayType === "3" ? "2px solid" : "0px"}}>공지사항</h2></div>
            <div className="qa-wait-title" onClick={() => ChangeView("4")}><h2 style={{fontWeight: props.DisplayType === "4" ? "bold" : "normal", borderBottom: props.DisplayType === "4" ? "2px solid" : "0px"}}>1:1문의 대기({state.QA_Wait_Count})</h2></div>
            <div className="qa-apply-title" onClick={() => ChangeView("5")}><h2 style={{fontWeight: props.DisplayType === "5" ? "bold" : "normal", borderBottom: props.DisplayType === "5" ? "2px solid" : "0px"}}>1:1문의 완료</h2></div>
            <div className="faq-title" onClick={() => ChangeView("6")}><h2 style={{fontWeight: props.DisplayType === "6" ? "bold" : "normal", borderBottom: props.DisplayType === "6" ? "2px solid" : "0px"}}>FAQ</h2></div>
            <div className="guide-title" onClick={() => ChangeView("7")}><h2 style={{fontWeight: props.DisplayType === "7" ? "bold" : "normal", borderBottom: props.DisplayType === "7" ? "2px solid" : "0px"}}>가이드</h2></div>
            <div className="terms-title" onClick={() => ChangeView("8")}><h2 style={{fontWeight: props.DisplayType === "8" ? "bold" : "normal", borderBottom: props.DisplayType === "8" ? "2px solid" : "0px"}}>약관</h2></div>
            <div className="logout" onClick={() => LogOutClick()}><h2>로그아웃</h2></div>
        </div>
    </div>
    );
}

export default Title